export const ICON_OPTIONS = [
  {
    value: 'https://api.iconify.design/mdi:database.svg?color=%238752FF',
    label: '数据库图标',
    preview: 'https://api.iconify.design/mdi:database.svg?color=%238752FF',
  },
  {
    value: 'https://api.iconify.design/mdi:file-document.svg?color=%23C852FF',
    label: '文档图标',
    preview: 'https://api.iconify.design/mdi:file-document.svg?color=%23C852FF',
  },
  {
    value: 'https://api.iconify.design/mdi:chart-line.svg?color=%23E470AC',
    label: '图表图标',
    preview: 'https://api.iconify.design/mdi:chart-line.svg?color=%23E470AC',
  },
  {
    value: 'https://api.iconify.design/mdi:table.svg?color=%23E49370',
    label: '表格图标',
    preview: 'https://api.iconify.design/mdi:table.svg?color=%23E49370',
  },
  {
    value: 'https://api.iconify.design/mdi:folder.svg?color=%2372C85C',
    label: '文件夹图标',
    preview: 'https://api.iconify.design/mdi:folder.svg?color=%2372C85C',
  },
  {
    value: 'https://api.iconify.design/mdi:cloud.svg?color=%2345B7D1',
    label: '云存储图标',
    preview: 'https://api.iconify.design/mdi:cloud.svg?color=%2345B7D1',
  },
  {
    value: 'https://api.iconify.design/mdi:archive.svg?color=%2396CEB4',
    label: '归档图标',
    preview: 'https://api.iconify.design/mdi:archive.svg?color=%2396CEB4',
  },
  {
    value: 'https://api.iconify.design/mdi:star.svg?color=%23FFEAA7',
    label: '星标图标',
    preview: 'https://api.iconify.design/mdi:star.svg?color=%23FFEAA7',
  },
] as const
